<div class="chips-container">
  <ng-content select="[prefix]"></ng-content>
  <div class="label">
    {{ text }}
  </div>
  <div #suffixWrapper [class.with-suffix]="!!suffixWrapper.children.length" layout>
    <ng-content select="[suffix]"></ng-content>
  </div>
  @if (showClose) {
    <rt-icon (click)="close.emit()" size="small-x" name="close" class="close"></rt-icon>
  }
</div>
